import { render, staticRenderFns } from "./genelamaclirapor.vue?vue&type=template&id=66819bbf&scoped=true&"
import script from "./genelamaclirapor.vue?vue&type=script&lang=js&"
export * from "./genelamaclirapor.vue?vue&type=script&lang=js&"
import style0 from "./genelamaclirapor.vue?vue&type=style&index=0&id=66819bbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66819bbf",
  null
  
)

export default component.exports